export const FETCH_BLOG = 'BlogDetail/FETCH_BLOG';
export const FETCH_BLOG_ERROR = 'BlogDetail/FETCH_BLOG_ERROR';
export const FETCH_BLOG_LIST = 'BlogDetail/FETCH_BLOG_LIST';
export const FETCH_BLOG_LIST_ERROR = 'BlogDetail/FETCH_BLOG_LIST_ERROR';
export const RESET_BLOG = 'BlogDetail/RESET_BLOG';
export const UPDATE_PAGE_NUMBER = 'BlogDetail/UPDATE_PAGE_NUMBER';
export const UPDATE_PAGE_NUMBER_FILTER = 'BlogDetail/UPDATE_PAGE_NUMBER_FILTER';